import { useTranslation } from "react-i18next";

import { getChartData, getEvenlySpacedYears } from "./CashFlowChart.helpers";

import CashFlowChart from "./CashFlowChart";

const CashFlowChartContainer = ({
  conclusionsPro,
  activePosition,
}: {
  conclusionsPro: any;
  activePosition: 10 | 20 | 30;
}) => {
  const { t } = useTranslation();

  const chartData = getChartData({ t, conclusionsPro, activePosition });

  const yearsToShow = getEvenlySpacedYears(chartData.charts[0].data, 12);

  return <CashFlowChart chartData={chartData} yearsToShow={yearsToShow} />;
};

export default CashFlowChartContainer;
